import router from '../router'

const routingStore = {
    namespaced: true,
    state: {
        scope: 'tenant',
        nextRoute: '',
        expandedConcept: null,
        conceptViewingType: null,
        expandedBlock: {
          open: false,
          blockId: null,
          conceptId: null,
        }
    },
    getters: {
    },
    actions: {
      pushRoute(context, route) {
        router.push(route);
      },
      goToGroupHome(context, routeData){
        let { group = context.rootState.org.activeTrust } = routeData
        context.commit('setActiveTrust', group, {root: true});
        router.push('/' + group);
      },
      goToConcept(context, routeData){
        let { slug, group = context.rootState.org.activeTrust } = routeData
        context.commit('setActiveTrust', group, {root: true});
        router.push('/' + group + '/' + slug);
      },
      goToConceptReferences(context, routeData){
        let { slug, group = context.rootState.org.activeTrust } = routeData
        context.commit('setActiveTrust', group, {root: true});
        router.push('/' + group + '/' + slug + '/references');
      },
      navigate(context, route) {
        if(route.fullPath == '/') {
          context.commit('setExpandedConcept', { conceptUrl: null });
          context.commit('setConceptViewingType', { viewingType: null });
        } else if (route.fullPath == '/entrance') {
          // nothing for entrance
        } else {
          console.log('navigating to ', route)
          let inspectUrl = route.fullPath.split('/');
          console.log('navigate inspectUrl', inspectUrl)

          // Don't want to do this cause then it would catch /entrance in the url
          //
          // let activeTrust = inspectUrl[1];
          // context.commit('setActiveTrust', { activeTrust });

          if(inspectUrl.length > 1) {
            let conceptUrl = inspectUrl[2];
            context.commit('setExpandedConcept', { conceptUrl });
          }

          if(inspectUrl.length > 2){
            if(inspectUrl[3] == 'references') {
              let viewingType = 'References';
              context.commit('setConceptViewingType', { viewingType }); // set after we've set expandedBlock.blockId

              // if(inspectUrl.length > 3){
              //   let referenceId = inspectUrl[3];
              //   console.log('referenceId', referenceId)
              //   context.commit('setExpandedBlockId', { blockId: referenceId });
              //   context.commit('setExpandedBlockOpen', { open: true });
              // }


            } else {
              // let ideaId = inspectUrl[2];
              // console.log('ideaId', ideaId)
              // context.commit('setExpandedBlockId', { blockId: ideaId });
              // context.commit('setExpandedBlockOpen', { open: true });
            }
          }
        }
      },

      openBlock(context, { blockId, conceptId }) {
        context.commit('setExpandedBlockId', { blockId });
        context.commit('setExpandedBlockConceptId', { conceptId });
        context.commit('setExpandedBlockOpen', { open: true });
        // console.log('openBlock', window.history.state)
        // window.history.pushState({}, null, window.history.state.current + '/' + blockId)
      },
      closeBlock(context) {
        context.commit('setExpandedBlockOpen', { open: false });
        context.commit('setExpandedBlockId', { blockId: null });
        // let currentPath = window.history.state.current;
        // console.log('closeBlock', currentPath)
        // let currentPaths = currentPath.split('/');
        // currentPaths.pop();
        // console.log('closeBlock', currentPath, currentPaths)
        // let newPath = currentPaths.join('/');
        // console.log('closeBlock', newPath)
        // window.history.pushState({}, null, newPath);

        // learnings:
        // - can't rely on window state
        // - should move the state of viewing type to routing
        // - so that each change of state the url can always be reconstructed
        // - may want to look at using normal push state, but I think that would complicate things
        // - yeah should try just pushing state and seeing why it wouldn't work, otherwise rebuild the url
      },
    },
    mutations: {
      setExpandedConcept(state, { conceptUrl }) {
        state.expandedConcept = conceptUrl;
      },
      setConceptViewingType(state, { viewingType }) {
        state.conceptViewingType = viewingType;
      },
      setExpandedBlockId(state, { blockId }){
        state.expandedBlock.blockId = blockId;
      },
      setExpandedBlockConceptId(state, { conceptId }){
        state.expandedBlock.conceptId = conceptId;
      },
      setExpandedBlockOpen(state, { open }){
        state.expandedBlock.open = open;
      },
    },
}
export default routingStore;
